import { GetSearchData, GetPDFWithFilename, GetPDFFileList } from "./FetchData";
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import FilterContexts from "../../Variables/FilterContexts";
import { toast } from "react-toastify";
import { Document, Page, pdfjs } from "react-pdf";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { Dialog, DialogHeader, DialogBody, Button} from "@material-tailwind/react";
import AddImageFromPDF from "./AddImageFromPDF";
// pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js"
pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.worker.min.mjs'

const pdfTypeList = ["OCT_G", "OCT_M", "AL", "VF"]

const AddImagePage = ({sendImagesBack}) => {
    const [isAddImageOpen, setIsAddImageOpen] = useState(false);

    const openAddImage = () => {
        setIsAddImageOpen(true);
    }
    const closeAndGetImage = (images) => {
        if(images){
            // console.log("images:",images)
            sendImagesBack(images)
        }
        setIsAddImageOpen(false);
    }

    return(
        <>
            <Button variant=" outlined" className=" text-lg" onClick={openAddImage}>PDF截圖</Button>
            <Dialog open={isAddImageOpen} handler={openAddImage} >
                <DialogHeader className=" justify-end"><Button onClick={() => closeAndGetImage(null)} className=" text-base">Close</Button></DialogHeader>
                <DialogBody className=" overflow-auto w-full h-full">
                    <AddImageFromPDF onClose={closeAndGetImage}></AddImageFromPDF>
                </DialogBody>
            </Dialog>
        </>
    )
}

const AddPDF = forwardRef(({record_id, onlyForRead}, ref) => {
    
    const {datas, updateFunc} = useContext(FilterContexts)
    const [fetchedPDF, setFetchedPDF] = useState([]);
    const [updateList, setUpdateList] = useState({uploadList: [], deleteList: []})
    const [PDFListForToday, setPDFListForToday] = useState({});
    const [lastType, setLastType] = useState(null);
    const [PDFUrl, setPDFUrl] = useState({});
    
    const typeRef = useRef(null);
    const fileRef = useRef(null);
    
    useImperativeHandle(ref, () => ({
        getPDF: () => PDFListForToday,
        setPDFFromRecord: (list) => setPDFListForToday(list),
        storeNow: () => setPDFListForToday(prevState => (
                {
                    ...prevState,
                    [lastType]: updateList
                }
            )),
        clearPDF: (record_id) => {
                clearAllPDF(record_id)
            },
        recoverPDF: () => {
                recoverTypeContent()
            }
    }))

    const fetchURLFile = async (record_id, type, file) => {
        const pdfFile = await GetPDFWithFilename(`/test_pdf/${record_id}/${type}/${file}`)
        try{
            return pdfFile;
        }
        catch(error){
            console.log("fail to fetch url", error);
            return null;
        }
    }

    const previewFile = async(record_id, type, file) => {
        let url = null;
        let targetFile = await fetchURLFile(record_id, type, file);
        try{
            url = URL.createObjectURL(targetFile);
        }
        catch(error){
            console.log('fail create url', error)
            toast.error(file+'讀取失敗');
        }

        if(url){
            setPDFUrl(prevState => ({
                ...prevState,
                [file]: {
                    'url': url,
                    'type': targetFile.type
                }
            }
            ))
        }
    }

    const showFiles = async(needAskPDF, record_id, type, file) => {
        let url = null;
        let urlTarget = file.file ? file.file : file;
        let alertLoading = null;
        if(needAskPDF){
            alertLoading = toast.loading('開啟中')
            const response = await fetchURLFile(record_id, type, file)
            urlTarget = response;
        }

        try{
            url = URL.createObjectURL(urlTarget);
            if(alertLoading)toast.dismiss(alertLoading)
        }
        catch(error){
            console.log('fail create url', error)
            toast.error('開啟失敗');
        }

        if(url){
            const pdfWindow = window.open(url, '_blank');
            if(pdfWindow){
                pdfWindow.addEventListener('beforeunload', function(event){
                    URL.revokeObjectURL(url);
                })
            }
        }
    }

    const displayFiles = ( files, needAskPDF, fileType ) => {
        // console.log(needAskPDF ,files)
        if(!files)return (<></>)
        return( 
            <>
                {!needAskPDF && files.length > 0 ? <td>{fileType}</td> : <></>}
                {files.map((file, index) => (
                    (!needAskPDF || !updateList.deleteList.includes(needAskPDF ? file : index)) ? 
                    (<td className="px-2 w-auto">
                        {!onlyForRead ? <button className="py-1 bg-[#0000] text-[#2a78a5] text-3xl" style={{borderRadius:".5em"}} onClick={(event) => cancelPDF(fileType, needAskPDF ? file : index, needAskPDF)}>-</button> : <></>}
                        {onlyForRead ?  
                            <>
                                {PDFUrl[file] ?          
                                    <div className="w-96 text-center">
                                        <button className="text-2xl" onClick={(event) => window.open(PDFUrl[file].url, '_blank')}>{file}</button>
                                        {/* <iframe className=" w-full h-96" title={`pdf_${index}`} src={PDFUrl[index]}></iframe> */}
                                        { PDFUrl[file].type === 'application/pdf' ? 
                                            <Document 
                                                file={PDFUrl[file].url}
                                            >
                                                <Page pageNumber={1} scale={0.7}/>
                                            </Document> : 
                                            <img src={PDFUrl[file].url} alt={`this should be ${file}`} className="w-fit h-fit m-auto"></img>
                                        }
                                    </div>
                                : <></>}
                            </>:
                            needAskPDF ?
                                <>
                                    <button onClick={(event) => showFiles(needAskPDF, record_id, typeRef.current.value, file)}>{file}</button>
                                </> : 
                                <>
                                    <button className="m-1 py-1 px-2 bg-[#399b25] text-[#fff] " style={{borderRadius:".5em"}} onClick={(event) => showFiles(needAskPDF, record_id, typeRef.current.value, file)}>{`開啟檔案`}</button>
                                    <input type="text" className=" border rounded-md px-2" value={needAskPDF ? file : file.fileName} onChange={(event) => {changeFileName(fileType, index, event.target.value)}}></input>
                                </>
                        }
                    </td>) : 
                    (<></>)
                ))}
            </>
        )
    }
    
    const pushNewFile = () => {
        if(fileRef.current.files[0]){
            let file = fileRef.current.files[0];
            setUpdateList(prevState => (
                {
                    ...prevState,
                    uploadList: [...prevState.uploadList, 
                        {
                            file: file,
                            fileName: (file.name).split('.')[0]
                        }
                    ],
                }
            ))
        }
    }

    const addPDFImagesToList = (images) => {
        console.log(images)
        images.forEach((image) => {
            const byteCharacters = atob(image.url.split(',')[1]);
            const byteArrays = [];
            for (let offset = 0; offset < byteCharacters.length; offset++) {
                const byteArray = byteCharacters.charCodeAt(offset);
                byteArrays.push(byteArray);
            }
            const imageBlob = new Blob([new Uint8Array(byteArrays)], { type: 'image/png' });
            
            let newUnit = {
                    file: imageBlob,
                    fileName: image.default_name,
                };
            
            setPDFListForToday(prevState => (
                {
                    ...prevState,
                    [image.fileType]: {
                        uploadList: prevState[image.fileType] && prevState[image.fileType].uploadList ? [...prevState[image.fileType].uploadList, newUnit] : [newUnit],
                        deleteList: prevState[image.fileType] && prevState[image.fileType].deleteList ? prevState[image.fileType].deleteList : []
                    }
                }
            ))
            return;
        })
    }

    const changeFileName = async(type, index, newName) => {
        if(!PDFListForToday[typeRef.current.value] || updateList!==PDFListForToday[typeRef.current.value]){
            setPDFListForToday(prevState => (
                {
                    ...prevState,
                    [typeRef.current.value]: updateList
                }
            ))
        }
        let newFiles = type===typeRef.current.value ? updateList.uploadList : PDFListForToday[type].uploadList;
        newFiles[index].fileName = newName;
        if(type===typeRef.current.value){
            setUpdateList(prevState => (
                {
                    ...prevState,
                    uploadList: newFiles
                }
            ))
        }
        else{
            setPDFListForToday(prevState => (
                {
                    ...prevState,
                    [type]: {
                        ...prevState[type],
                        uploadList: newFiles
                    }
                }
            ))
        }
    } 

    const cancelPDF = (type, index, isUpdated) => {
        let isType = type===typeRef.current.value;
        if(!isUpdated){
            if(isType){
                let temArray = updateList.uploadList.filter((file, ind) => ind!==index);
                setUpdateList(prevState => (
                    {
                        ...prevState,
                        uploadList: temArray
                    }
                ))
            }
            else{
                let temArray = PDFListForToday[type].uploadList.filter((file, ind) => ind!==index);
                setPDFListForToday(prevState => (
                    {
                        ...prevState,
                        [type]: {
                            ...prevState[type],
                            uploadList: temArray
                        }
                    }
                ))
            }
        }
        else{
            // console.log(type, typeRef.current.value)
            if(isType){
                setUpdateList(prevState => (
                    {
                        ...prevState,
                        deleteList: [...prevState.deleteList, index]
                    }
                ))
            }
            else{
                setPDFListForToday(prevState => (
                    {
                        ...prevState,
                        [type]: {
                            ...prevState[type],
                            deleteList: [...prevState[type].deleteList, index]
                        }
                    }
                ))
            }
        }
    }

    const clearAllPDF = async( eye_record_record_id ) => {
        const temList = {}
        const currentType = typeRef.current.value;
        pdfTypeList.forEach((type) => {
            if(type !== currentType){
                GetPDFFileList(`/test_pdf/${eye_record_record_id}/${type}`)
                    .then( response => {
                        // console.log(type,response)
                        temList[type] = {
                            uploadList: [],
                            deleteList: response.filenames,
                        }
                    })
                    .catch(error => {
                        console.log("error in clearAll",error)
                        toast.error('發生錯誤，請手動刪除檔案')
                    })
            }
            else{
                temList[type] = {
                    uploadList: [],
                    deleteList: fetchedPDF,
                }
            }    
        })
        setPDFListForToday(temList)
    }

    const recoverTypeContent = () => {
        const recoveredList = {};
        pdfTypeList.forEach((type) => {
            recoveredList[type] = 
                {
                    uploadList: [],
                    deleteList: [],
                }
        })
        setPDFListForToday(recoveredList)
    }

    const changeType = (type) => {
        const temList = updateList;
        updateFunc("pdfType", type)
        setPDFListForToday(prevState => (
            {
                ...prevState,
                [lastType]: temList
            }
        ))
        setUpdateList(PDFListForToday[type] ? PDFListForToday[type] : {uploadList: [], deleteList: []})
    }

    if(!datas.pdfType){updateFunc("pdfType", "OCT_G")}

    let pdfFileList = GetSearchData(record_id ? `test_pdf/${record_id}/${datas.pdfType}` : null, false)

    useEffect(() => {
        console.log(pdfFileList)
        try{
            setFetchedPDF(pdfFileList.filenames)
        }
        catch(error){
            console.log("fail on fetch",error)
        }
    }, [pdfFileList])

    useEffect(() => {
        if(onlyForRead){
            try{
                setPDFUrl({});
                fetchedPDF.forEach((file) => {
                    previewFile(record_id, typeRef.current.value, file);
                })
            }
            catch(error){
                console.log("fail on fetch",error)
            }
        }
    }, [fetchedPDF])

    useEffect(() => {
        // console.log("new",updateList)
        setLastType(typeRef.current.value)
    }, [updateList])

    useEffect(() => {
        // console.log("all",PDFListForToday)
        setUpdateList(PDFListForToday[typeRef.current.value] ? PDFListForToday[typeRef.current.value] : {uploadList: [], deleteList: []})
    }, [PDFListForToday])
    
    return (
        <>
            {/* <button onClick={()=>console.log(updateList, PDFListForToday)}>測試</button> */}
            <tr>
                <td colSpan={1}></td>
                <td>
                    <label for="selectPDF">選擇檔案種類</label>
                    <select name="selectPDF" ref={typeRef} onChange={(event) => changeType(event.target.value)} >
                        {pdfTypeList.map((type) => (<option value={type}>{type}</option>))}
                    </select>
                </td>
            </tr>
            <>
                {onlyForRead ? (<></>) : (
                    <tr>
                        <td colSpan={1}></td>
                        <td colSpan={2}>
                            <div className="flex flex-nowrap">
                                <input type="file" accept=".pdf, .jpg, .png, .jpeg" ref={fileRef} onChange={(event) => pushNewFile(event.target.files[0])} className="px-2"></input>
                                <AddImagePage sendImagesBack={addPDFImagesToList}></AddImagePage>
                            </div>
                        </td>
                    </tr>
                )}
                <tr>
                    <td colSpan={1}></td>
                    <td colSpan={100}>
                        <table className="ml-10">
                            <tr key="oldPDF">
                                {fetchedPDF ? 
                                    displayFiles(fetchedPDF, true, typeRef.current ? typeRef.current.value : 'OCT_G')
                                    : (<></>)}
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td colSpan={1}></td>
                    <td colSpan={100}>
                        <table className="ml-10">
                            {!onlyForRead ?  
                                <>
                                <tr key="newUpload">
                                    <td>新上傳：</td>
                                </tr>
                                <>
                                    {pdfTypeList.map((type) => (
                                        <>
                                            {type===(typeRef.current && typeRef.current.value ? typeRef.current.value : "OCT_G") ? 
                                            <tr>
                                                {displayFiles(updateList.uploadList, false, type)}
                                            </tr> : 
                                            <tr>
                                                {PDFListForToday[type] ? displayFiles(PDFListForToday[type].uploadList, false, type) : <></>}
                                            </tr>}
                                        </>
                                    ))}
                                </>
                                </>
                                : <></>}
                        </table>
                    </td>
                </tr>
            </>
        </>
    )
})

export default AddPDF;
